// Utilities for detecting and recovering from stale-chunk errors after a deploy.
// Extracted here so ErrorBoundary components can import without creating a
// circular dependency back to the app entry point (index.tsx).

export const CHUNK_EB_RELOAD_AT_KEY = 'chunk_eb_reload_at';
export const PRELOAD_RELOAD_COOLDOWN_MS = 30_000;

// Set to true by index.tsx's build-freshness poller when the deployed backend
// build ID diverges from the one baked into this bundle.
let _staleBuild = false;
export function markBuildStale(): void {
  _staleBuild = true;
}

// Returns true when an error is caused by a stale React.lazy() chunk — either a
// chunk that 404'd (vite:preloadError handles that at the network level) or a
// chunk that loaded but whose default export is undefined because it was served
// from an old deploy version that no longer matches the current bundle.
export function isStaleChunkError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : String(error ?? '');
  return (
    msg.includes("_result.default") ||
    msg.includes("'default'") ||
    msg.includes('"default"') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('Unable to preload CSS') ||
    msg.includes('dynamically imported module')
  );
}

// Call from an ErrorBoundary's render phase. Returns true (and triggers a
// reload) when the error looks like a stale chunk or when the stale-build flag
// is set. A cooldown prevents reload loops.
export function maybeReloadOnChunkError(error: unknown): boolean {
  if (!isStaleChunkError(error) && !_staleBuild) return false;
  const lastAttempt = Number(sessionStorage.getItem(CHUNK_EB_RELOAD_AT_KEY)) || 0;
  if (Date.now() - lastAttempt < PRELOAD_RELOAD_COOLDOWN_MS) return false;
  sessionStorage.setItem(CHUNK_EB_RELOAD_AT_KEY, String(Date.now()));
  window.location.reload();
  return true;
}
